/**
 * Browser entry point. Mounts {@link App} into `#root`.
 *
 * The bundler (Vite, esbuild, webpack — chosen by the deploy pipeline)
 * is expected to consume this file as the SPA entry. The `tsc -p
 * tsconfig.json` build only type-checks; bundling is a downstream step.
 */

import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './batches/BatchTransferTools.css';
import './consignment/ownership-label.css';
import './consignment/consignment-accounting.css';

const rootEl = typeof document !== 'undefined' ? document.getElementById('root') : null;
if (rootEl !== null) {
  createRoot(rootEl).render(<App />);
}

export { App } from './App';
